/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GARIds
 */
export interface GARIds {
  /**
   *
   * @type {string}
   * @memberof GARIds
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GARIds
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GARIds
   */
  deliveryAccountableParty?: string | null;
  /**
   *
   * @type {string}
   * @memberof GARIds
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GARIds interface.
 */
export function instanceOfGARIds(value: object): value is GARIds {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GARIdsFromJSON(json: any): GARIds {
  return GARIdsFromJSONTyped(json, false);
}

export function GARIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GARIds {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    deliveryAccountableParty:
      json["delivery_accountable_party"] === undefined
        ? undefined
        : json["delivery_accountable_party"] === null
        ? null
        : json["delivery_accountable_party"],
    dataOwner: json["data_owner"],
  };
}

export function GARIdsToJSON(json: any): GARIds {
  return GARIdsToJSONTyped(json, false);
}

export function GARIdsToJSONTyped(
  value?: Omit<GARIds, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    data_owner: value["dataOwner"],
  };
}
